import React from 'react'
import Header from './Header'
import Footer from './Footer'
import StickyRoundyChatNow from './StickyRoundyChatNow'

const Layout = ({ children }) => {
    const layoutStyle = {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%"
    }
    return (
        <div style={layoutStyle}>
            <Header />
            {children}
            <Footer />
            {/* <StickyRoundyChatNow/> */}
        </div>
    )
}

export default Layout